import React, { useContext } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { ModalContext } from "context/ModalContext";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import CloseIcon from "@mui/icons-material/Close";
import Iconify from "components/Iconify";
import colors from "assets/theme/base/colors";
import SubmitButton from "components/SubmitButton";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: `${colors.modal.backGround}`,
  borderRadius: "8px",
  maxWidth: "870px",
  width: "90%",
  overflowY: "auto",
  overflowX: "hidden",
  maxHeight: "90%",
  height: "auto",
  pt: 0,
  "&:focus": {
    outline: "none",
  },
};

const MDModal = ({ hasButton, btnText, modalHead, children }) => {
  const { open, setOpen, handleOpenModal } = useContext(ModalContext);
  const handleCloseModal = () => setOpen(false);
  const { info, white } = colors;

  return (
    <div>
      {hasButton && (
        <SubmitButton
          onClick={handleOpenModal}
          type="button"
          color={info.color}
          btnText={
            <>
              <Iconify icon="solar:add-square-bold" />
              {btnText}
            </>
          }
        ></SubmitButton>
      )}
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <MDBox
            component="div"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              position: "sticky",
              top: "0px",
              zIndex: "1000",
              backgroundColor: `${colors?.modal?.backGround}`,
              padding: "20px 32px 20px 32px",
              marginLeft: "-1px",
            }}
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              color={colors.modal.text}
              sx={{ fontSize: "20px" }}
            >
              {modalHead}
            </Typography>
            <CloseIcon
              onClick={handleCloseModal}
              sx={{
                cursor: "pointer",
                padding: "6px",
                width: "35px",
                height: "35px",
                borderRadius: "50px",
                transition: "all 0.2s ease-in-out",
                color: `${colors?.modal?.text} !important`,
                "&:hover": {
                  backgroundColor: `${colors?.modal?.btnHover} !important`,
                  color: `${colors?.modal?.textHover} !important`,
                },
              }}
            />
          </MDBox>
          <Typography sx={{ padding: "0px 32px 32px 32px" }}>{children}</Typography>
        </Box>
      </Modal>
    </div>
  );
};
MDModal.propTypes = {
  hasButton: PropTypes.boolean,
  btnText: PropTypes.string,
  modalHead: PropTypes.string,
  children: PropTypes.node.isRequired,
};
export default MDModal;
